var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZToASorting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-arrow-down-az-icon lucide-arrow-down-a-z",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 16 4 4 4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20V4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8h-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14h5l-5 6h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZToASorting);
export default __webpack_public_path__ + "static/media/z-to-a-sorting.5e3dd13aab35397d064659b75311eb77.svg";
export { ForwardRef as ReactComponent };